import React, {Component} from 'react';

class StoriesController extends Component{
  constructor(props){
    super(props);
  }
  render(){
    let template = '';
    this.props.content.lines.map( (item, index ) => {
      template += `<div class='col-5'><strong>${item.number}</strong> <span>${item.text}</span></div>`;
    })
    return(
      <section className="stories">
        <h2>{this.props.content.title}</h2>
        <p>{this.props.content.description}</p>
        <div className="row">
          <div className="col-2">
            <img width="100%" src={this.props.content.imgDeveloper} />
          </div>
          <div className="col-6">
            <img width="100%" src={this.props.content.imgInfoGraph} />
          </div>
        </div>
      </section>
    )
  }
}

export default StoriesController;



// WEBPACK FOOTER //
// ./src/components/homepage/views/stories.js